// Module
var code = "<div class=\"details-container\"> <p class=\"popup-title\">{{message}}</p> <div layout=\"row\" style=\"justify-content:center\"> <button class=\"details-container__btn\" ng-click=\"cancel()\">OK</button> </div> </div>";
// Exports
var _module_exports = code;;
var path = 'app/modals/info-message.modal.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;